/**
 * @description 导出默认通用配置
 */
const setting = {
  title: "medmix",
};
module.exports = setting;
